import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    const token = localStorage.getItem("familyos_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("familyos_token");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMe();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) {
      return data; // caller handles 2FA challenge
    }
    localStorage.setItem("familyos_token", data.token);
    await fetchMe();
    return data;
  };

  const verify2FA = async (challenge_id, code) => {
    const { data } = await api.post("/auth/verify-2fa", { challenge_id, code });
    localStorage.setItem("familyos_token", data.token);
    await fetchMe();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("familyos_token", data.token);
    await fetchMe();
    return data;
  };

  const logout = () => {
    localStorage.removeItem("familyos_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verify2FA, register, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
